import React from "react";

/**
 * Renders a self-hosted legal document (Privacy Policy / Terms) as a
 * full-viewport page. The document is a standalone styled HTML file served
 * from /public/legal, isolated in an iframe so its styles never leak into the
 * app. Public route — no authentication required (needed for Play/App Store).
 */
export default function LegalPage({ src, title }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "#fbfaf7" }}>
      <iframe
        src={src}
        title={title}
        data-testid="legal-doc-frame"
        style={{ border: "none", width: "100%", height: "100%", display: "block" }}
      />
    </div>
  );
}
